import { PlusOutlined, CloseOutlined } from '@ant-design/icons'
import { useState, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '@/hooks'
import { setRects, setTechTags } from '@/features/SetSelectedRects/setSelectedRects'
import { ILocalInfo } from '@/features/SetSixLawsInfo/setSixLawsInfo'
import { Select } from 'antd'
interface TagTreeI {
  value: string
  label: string
}

const Gufa = () => {
  const dispatch = useAppDispatch()
  //根据当前选中的局部标签确定被选中的框的areaId
  const _selectedRects = useAppSelector((state) => state.selectedRects.rects)
  const localInfo = useAppSelector((state) => state.sixLawsInfo.localInfo)
  const [gufaTrees, setGufaTrees] = useState<TagTreeI[]>([])
  const localTagTree = useAppSelector((state) => state.sixLawsInfo.localTagTree)
  const selectedObjTags = useAppSelector((state) => state.selectedRects.objTags)
  const selectedTechTags = useAppSelector((state) => state.selectedRects.techTags)
  const [currentTags, setCurrentTags] = useState<string[]>([])
  const [inputTags, setInputTags] = useState<string>('')

  useEffect(() => {
    const newGufaTrees: TagTreeI[] = []
    for (let i = 0; i < localTagTree.技法.length; i++) {
      newGufaTrees.push({
        value: localTagTree.技法[i],
        label: localTagTree.技法[i]
      })
    }
    setGufaTrees(newGufaTrees)
  }, [localTagTree])

  //设置当前画作的技法tags
  useEffect(() => {
    const newCurrentTags: string[] = []
    for (let i = 0; i < localInfo.length; i++) {
      const jifaTags = localInfo[i].tags.filter((item) => item.typeName === '技法')
      if (jifaTags.length > 0) {
        for (let j = 0; j < jifaTags[0].tags.length; j++) {
          if (!newCurrentTags.includes(jifaTags[0].tags[j])) {
            newCurrentTags.push(jifaTags[0].tags[j])
          }
        }
      }
    }
    setCurrentTags(newCurrentTags)
  }, [localInfo])

  //根据selectedTag变化决定被选中的rects
  useEffect(() => {
    const newSelectedRects: ILocalInfo[] = []
    for (let i = 0; i < localInfo.length; i++) {
      let flag = false
      for (let j = 0; j < selectedObjTags.length; j++) {
        if (
          localInfo[i].tags
            .filter((item) => item.typeName === '物象')?.[0]
            .tags.includes(selectedObjTags[j])
        ) {
          newSelectedRects.push(localInfo[i])
          flag = true
          break
        }
      }
      if (flag === false) {
        for (let j = 0; j < selectedTechTags.length; j++) {
          if (
            localInfo[i].tags
              .filter((item) => item.typeName === '技法')?.[0]
              .tags.includes(selectedTechTags[j])
          ) {
            newSelectedRects.push(localInfo[i])
            break
          }
        }
      }
    }
    dispatch(setRects(newSelectedRects))
  }, [dispatch, localInfo, selectedObjTags, selectedTechTags])

  return (
    <div className='gufa-panel'>
      <div className='gufa-title'>
        <h2>骨法用笔</h2>
        <div className='addNewTag'>
          <Select
            value={'技法'}
            options={gufaTrees}
            onChange={(value) => {
              if (!currentTags.includes(value)) {
                setCurrentTags([...currentTags, value])
              }
            }}
          />
          <div className='addNewTag-divider'></div>
          <input
            className='addNewTag-input'
            value={inputTags}
            onChange={(e) => {
              setInputTags(e.target.value)
            }}
          ></input>
          <div
            className='addNewTag-addButton'
            onClick={() => {
              if (inputTags !== '' && !currentTags.includes(inputTags)) {
                setCurrentTags([...currentTags, inputTags])
                setInputTags('')
              }
            }}
          >
            <PlusOutlined style={{ color: 'white' }} />
          </div>
        </div>
      </div>
      <div className='gufa-tags'>
        {currentTags.map((item) => {
          return (
            <div
              className={selectedTechTags.includes(item) ? 'editableTag-selected' : 'editableTag'}
              key={item}
            >
              <div
                className='editableTag-title'
                onClick={() => {
                  let newSelectedTags: string[] = []
                  if (selectedTechTags.includes(item)) {
                    newSelectedTags = selectedTechTags.filter((temp) => temp !== item)
                  } else {
                    newSelectedTags = [...selectedTechTags]
                    newSelectedTags.push(item)
                  }
                  dispatch(setTechTags(newSelectedTags))
                }}
              >
                {item}
              </div>{' '}
              <button
                className='editableTag-delete'
                onClick={() => {
                  const newCurrentTags = currentTags.filter((i) => i !== item)
                  setCurrentTags(newCurrentTags)
                }}
              >
                <CloseOutlined className='editableTag-cross' />
              </button>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Gufa
